<template><LoadingOverlay loading /></template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { APIService } from "@/apps/core-app-onboarding/services/apiClient/api.service";
import {
  ERROR_CODES,
  ErrorHandler,
} from "@/apps/core-app-onboarding/helpers/errorHandlerWithLogger.helper";
import { AndroidInterface } from "@/apps/core-app-onboarding/services/android.service";
import LoadingOverlay from "@/shared-components/ui/core-app/LoadingOverlay.vue";

declare const Android: AndroidInterface;

export default defineComponent({
  name: "InitView",
  components: { LoadingOverlay },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const apiService = new APIService();

    onMounted(async () => {
      try {
        const response = await apiService.checkApplicationSource({
          applicationId: Android.getCreditLineApplicationId(),
        });

        //logging so there's no unused vars warning
        console.log(response);

        router.push({
          name: "LocationPickerView",
          query: route.query,
        });

        // Bring this back when we get the QR source param working
        // if (response.data.applicationSource === "play store") {
        //   router.push({
        //     name: "LocationPickerView",
        //     query: route.query,
        //   });
        // } else {
        //   router.push({ name: "PersonRegistrationLaunchView" });
        // }
      } catch (error) {
        console.error(error);
        ErrorHandler.logAPIError(error, ERROR_CODES.START_SESSION_API_ERROR);
      }
    });

    return {};
  },
});
</script>

<style lang="scss" scoped></style>
